// extracted by mini-css-extract-plugin
module.exports = {"title":"AwaitingExpertConfirmationComponent_title__SQPEq"};